import { Component, OnInit } from "@angular/core";
import { Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Location } from "src/app/models/Location";
import { ModalComponent } from "src/app/services/modal.service";

@Component({
  selector: "app-location-edit-modal",
  templateUrl: "./location-edit-modal.component.html",
  styleUrls: ["./location-edit-modal.component.scss"],
  standalone: false,
})
export class LocationEditModalComponent
  implements OnInit, ModalComponent<LocationEditModalComponent, Location>
{
  location: Location;

  constructor(
    public dialogRef: MatDialogRef<LocationEditModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: Location,
  ) {}

  ngOnInit(): void {
    this.location = Object.assign({}, this.data);
  }

  onEditLocation() {
    this.dialogRef.close(this.location);
  }

  onCancel() {
    // no need to emit any result
    this.dialogRef.close();
  }
}
